import { connect } from 'react-redux';
import { createSelector } from 'reselect';

// import { deleteEvent, fetchCalendar, updateEvent } from '../redux/calendar';
import { deliveryModalConfirm, deliveryModalUpdate, toggleDeliveryModal } from '../../../redux/modals';
import DeliveryModal from './DeliveryModal';

const standardCrewsSelector = createSelector(
  state => state.standardCrews.crews,
  state => state.modals.deliveryModal.purchaseOrder,
  (standardCrews, purchaseOrder) => {
    const office = purchaseOrder ? purchaseOrder.office : null;
    return standardCrews
      .filter(c => c.deliveryCrew)
      .map(c => ({
        ...c,
        disabled: !!office && !!c.office && c.office.id !== office.id
      }));
  }
);

const mapStateToProps = state => ({
  ...state.modals.deliveryModal,
  standardCrews: standardCrewsSelector(state)
});

const mapDispatchToProps = {
  onChange: deliveryModalUpdate,
  onConfirm: deliveryModalConfirm,
  onHide: () => toggleDeliveryModal()
};

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryModal);
